// An incursive function to take routes and return the child element with path === :orgName and return the children
export const findOrgRoutes = (routes) => {
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].path === ':orgName') {
      return routes[i].children?.filter((route) => !!route.path)
    } else if (routes[i].children) {
      return findOrgRoutes(routes[i].children)
    }
  }
}
